// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdUserImportsDatatableResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      start_time: number,
      name: string,
      columns: number,
      total_rows: number,
      import_count: number,
      malformed_count: number,
      no_id_count: number,
      warning_rows: number,
      is_done: boolean,
      segment_id: nullOrUndefined,
      cancelled: boolean,
      download_link: string,
      has_error_report: boolean,
      is_uploaded_by_current_developer: boolean,
      should_make_filterable: boolean,
      developer: string,
      has_hit_rate_limit: boolean,
    })
  ),
});
